import {Backbone} from 'Vertebrae';
import {ProfileUser} from 'model/profileUser';

export const Users = Backbone.Collection.extend({
    _name: 'Users',
    model: ProfileUser,
    url: '/people.json',
});
